<script setup>
import { defineAsyncComponent, computed, useAttrs } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: '#919EAB',
  },
  fill: {
    type: String,
    default: null,
  },
  width: {
    type: [Number, String],
    default: 16,
  },
  height: {
    type: [Number, String],
    default: 16,
  },
});

const attrs = useAttrs();

const icons = {
  ...import.meta.glob('./Optimized/*.vue'),
  ...import.meta.glob('./Optimized/abs/*.vue'),
};

const iconComponent = computed(() => {
  const path = `./Optimized/${props.type}.vue`;
  const absPath = `./Optimized/abs/${props.type}.vue`;
  const loader = icons[path] ?? icons[absPath];
  if (!loader) {
    console.error(`Icon component not found for type: ${props.type}`);
    return null;
  }
  return defineAsyncComponent(loader);
});
</script>

<template>
  <component :is="iconComponent" v-bind="{ ...attrs, color: fill ?? color, width, height }" />
</template>

<style scoped></style>
